import script from "./ExecutiveInscriptionCalculation.vue?vue&type=script&setup=true&lang=js"
export * from "./ExecutiveInscriptionCalculation.vue?vue&type=script&setup=true&lang=js"

import "./ExecutiveInscriptionCalculation.vue?vue&type=style&index=0&id=7072050c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7072050c"]])

export default __exports__